export const SUGGESTED_MESSAGES = [
  'conversation.suggested_message.offer_more_photos',
  'conversation.suggested_message.offer_more_information',
  'conversation.suggested_message.offer_discount',
]
